import { render } from "./PdfGenerationTest.vue?vue&type=template&id=740890d7&scoped=true"
import script from "./PdfGenerationTest.vue?vue&type=script&lang=js"
export * from "./PdfGenerationTest.vue?vue&type=script&lang=js"

import "./PdfGenerationTest.vue?vue&type=style&index=0&id=740890d7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740890d7"]])

export default __exports__